import { SelectIcon } from 'assets/icons/SelectIcon'

export const SORT_OPTIONS: { value: string; label: string; icon: React.ReactElement }[] = [
  { value: 'created_at-desc', label: 'New first', icon: <SelectIcon style={{ transform: 'rotate(180deg)' }} /> },
  { value: 'created_at-asc', label: 'Old first', icon: <SelectIcon /> },
  { value: 'name-desc', label: 'Name z-a', icon: <SelectIcon style={{ transform: 'rotate(180deg)' }} /> },
  { value: 'name-asc', label: 'Name a-z', icon: <SelectIcon /> },
]

export const SORT_ICON_BY_VALUE = {
  'created_at-desc': <SelectIcon style={{ transform: 'rotate(180deg)' }} />,
  'created_at-asc': <SelectIcon />,
  'name-desc': <SelectIcon style={{ transform: 'rotate(180deg)' }} />,
  'name-asc': <SelectIcon />,
}

export const SORT_NAME_BY_ORDERBYDIRECTION_VALUE = {
  'created_at-desc': 'New first',
  'created_at-asc': 'Old first',
  'name-asc': 'Name a-z',
  'name-desc': 'Name z-a',
}
